import { REQUIRED_COARSE_SCOPES, REQUIRED_GRANULAR_SCOPES } from './constants';

export const useScopeChecks = (appInstallationScopes?: readonly string[]): boolean => {
	if (appInstallationScopes) {
		const appHasAllRequiredCoarseScopes = REQUIRED_COARSE_SCOPES.every((requiredScope) =>
			appInstallationScopes.includes(requiredScope),
		);

		if (appHasAllRequiredCoarseScopes) {
			return true;
		}

		return REQUIRED_GRANULAR_SCOPES.every((requiredScope) =>
			appInstallationScopes.includes(requiredScope),
		);
	}

	return false;
};
